import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { calendarioApi } from '../api/calendario';
import { CreateEventoDto, CreateNotaDto } from '../types/calendario';

export function useEventos(fechaInicio: string, fechaFin: string) {
  return useQuery({
    queryKey: ['eventos', fechaInicio, fechaFin],
    queryFn: () => calendarioApi.getEventos(fechaInicio, fechaFin),
    staleTime: 1000 * 60 * 2,
    enabled: !!fechaInicio && !!fechaFin && fechaInicio !== 'null' && fechaFin !== 'null',
  });
}

export function useCrearEvento() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateEventoDto) => calendarioApi.crearEvento(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['eventos'] }),
  });
}

export function useActualizarEvento() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<CreateEventoDto> }) =>
      calendarioApi.actualizarEvento(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['eventos'] }),
  });
}

export function useEliminarEvento() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => calendarioApi.eliminarEvento(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['eventos'] }),
  });
}

export function useNotas() {
  return useQuery({
    queryKey: ['notas'],
    queryFn: () => calendarioApi.getNotas(),
    staleTime: 1000 * 60 * 2,
  });
}

export function useCrearNota() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateNotaDto) => calendarioApi.crearNota(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notas'] }),
  });
}

export function useActualizarNota() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<CreateNotaDto & { completado?: boolean }> }) =>
      calendarioApi.actualizarNota(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notas'] }),
  });
}

export function useEliminarNota() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => calendarioApi.eliminarNota(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notas'] }),
  });
}

export function useCompletarNota() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, completado }: { id: number; completado: boolean }) =>
      calendarioApi.completarNota(id, completado),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notas'] }),
  });
}